module.exports = __webpack_public_path__ + "img/arrow.d103d610.svg";